import React from "react";
import { Tabs, PageHeader } from "antd";
import { Knowledge } from "./knowledge";
import { KnowledgeType } from "./knowledgeType";
const { TabPane } = Tabs;

export function KnowledgePage() {
    return (
        <>
            <PageHeader title="Lista conhecimentos" />
            <Tabs defaultActiveKey="1">
                <TabPane tab="Tipos de conhecimento" key="1">
                    <KnowledgeType />
                </TabPane>
                <TabPane tab="Conhecimentos" key="2">
                    <Knowledge />
                </TabPane>
            </Tabs>
        </>
    );
}
